import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPayrollReport } from "../../models/Payroll";
import { Incentive } from "../../models/Incentive";

const initialState = {
  selectedPartners: [] as number[],
  refetch: false,
  records: [] as IPayrollReport[],
  incentives: [] as Incentive[],
  page: 0,
  limit: 100,
  total: 0,
};

const payrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducers: {
    setSelectedPartners: (state, action) => {
      state.selectedPartners = action.payload;
    },
    addPartner: (state, action) => {
      state.selectedPartners = state.selectedPartners.includes(action.payload)
        ? state.selectedPartners.filter(
            (partnerId) => partnerId !== action.payload
          )
        : [...state.selectedPartners, action.payload];
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload;
    },
    setRecords: (state, action) => {
      state.records = action.payload;
    },
    setIncentives: (state, action) => {
      state.incentives = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },

    updateRecordByIndex: (
      state,
      action: PayloadAction<{
        index: number;
        data: IPayrollReport;
      }>
    ) => {
      const { index, data } = action.payload;
      if (state.records[index]) {
        // console.log('first')
        // state.records[index] = { ...state.records[index], ...data };
        const updated = [...state.records];
        updated[index] = { ...state.records[index], ...data };
        state.records = updated;
      }
    },
  },
});

export const {
  setSelectedPartners,
  addPartner,
  setRefetch,
  setRecords,
  updateRecordByIndex,
  setIncentives,
  setPage,
  setLimit,
  setTotal,
} = payrollSlice.actions;

export default payrollSlice.reducer;
